import { create } from "zustand";
import { persist } from "zustand/middleware";

const DEFAULT_LIMIT = 20;

interface PaginationState {
	limit: number;
}

interface PaginationActions {
	setLimit: (limit: number) => void;
}

export const usePaginationStore = create<PaginationState & PaginationActions>()(
	persist(
		(set) => ({
			limit: DEFAULT_LIMIT,
			setLimit: (limit: number) => set({ limit }),
		}),
		{
			name: "app-pagination-preferences",
			partialize: (state) => ({ limit: state.limit }),
		},
	),
);

export const getDefaultPaginationLimit = () =>
	usePaginationStore.getState().limit;
